var _path, _path2, _path3, _path4, _g, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22514 13.681C4.7869 13.681 4.34865 13.3888 4.20257 13.0236L0.331397 4.03959C0.112274 3.45526 0.331396 2.87093 0.915724 2.65181L5.00602 0.971866C5.29818 0.825784 5.59035 0.825784 5.88251 0.971866C6.17468 1.11795 6.3938 1.26403 6.46684 1.55619L10.338 10.5402C10.5571 11.1246 10.338 11.7089 9.75368 11.928L5.66339 13.5349L5.22514 13.681ZM5.44427 1.41011L5.22514 1.48315L1.13485 3.09005L0.842683 3.38222V3.74742L4.71386 12.7315C4.85994 12.9506 5.1521 13.0967 5.37122 13.0236L9.46152 11.4167L9.75368 11.1246V10.7594L5.95555 1.77532C5.80947 1.55619 5.66339 1.41011 5.44427 1.41011Z",
    fill: "#5A78FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M6.75816 2.14062L6.17383 2.35975L7.70769 5.93876L8.29202 5.71963L6.75816 2.14062Z",
    fill: "url(#paint0_linear_527_3694)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9.53423 10.1753L10.1186 9.95622L8.36558 5.93896L7.78125 6.15809L9.53423 10.1753Z",
    fill: "url(#paint1_linear_527_3694)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87737 7.47255C7.80163 7.85116 6.84441 8.50609 6.10182 9.37162L4.42188 5.57349C5.21511 4.75495 6.17065 4.11121 7.22721 3.68356C8.28378 3.2559 9.41806 3.05376 10.5573 3.0901L12.2373 6.88823C11.0686 6.81519 9.89995 7.03431 8.87737 7.47255Z",
    fill: "#5A78FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M8.87737 7.47304C7.80163 7.85164 6.84441 8.50658 6.10182 9.37211L4.42188 5.57398C5.21511 4.75544 6.17065 4.1117 7.22721 3.68404C8.28378 3.25639 9.41806 3.05425 10.5573 3.09058L12.2373 6.88872C11.0686 6.81567 9.89995 7.0348 8.87737 7.47304Z",
    fill: "url(#paint2_linear_527_3694)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M8.87737 7.47304C7.80163 7.85164 6.84441 8.50658 6.10182 9.37211L4.42188 5.57398C5.21511 4.75544 6.17065 4.1117 7.22721 3.68404C8.28378 3.25639 9.41806 3.05425 10.5573 3.09058L12.2373 6.88872C11.0686 6.81567 9.89995 7.0348 8.87737 7.47304Z",
    fill: "url(#paint3_linear_527_3694)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38841 8.64116C8.24796 8.59516 7.11519 8.84689 6.10156 9.37157V5.5004C7.12414 4.98911 8.29279 4.76999 9.38841 4.76999C10.5289 4.72399 11.6616 4.97572 12.6753 5.5004V9.37157C11.6527 8.86029 10.5571 8.64116 9.38841 8.64116Z",
    fill: "#5A78FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_527_3694",
    x1: 7.34248,
    y1: 4.98922,
    x2: 7.05032,
    y2: 2.14062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#504678",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#504678",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#504678",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504678",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_527_3694",
    x1: 8.94991,
    y1: 6.96154,
    x2: 9.09599,
    y2: 10.1023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#504678",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#504678",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#504678",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504678",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_527_3694",
    x1: 5.88269,
    y1: 7.83825,
    x2: 8.95042,
    y2: 5.72006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#504678",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#504678",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504678",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_527_3694",
    x1: 8.22001,
    y1: 5.28181,
    x2: 8.07392,
    y2: 4.1862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#504678",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504678",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.39cd61eba0b64b46c0b3da0e27d49e1b.svg";
export { ForwardRef as ReactComponent };